import { useContext, useEffect, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { AppContext } from "../../App";
import PopUp from "../PopUp";
import LoadIcon from "../../icons/LoadIcon";
import api from "../api/api";

function SatispayPopup({ order, edit }) {
	const { setSatispayPopup, init_cart, apiSettings, setConfirm, setLoading, loadNextSplittedOrder } =
		useContext(AppContext);

	const [status, setStatus] = useState("loading");
	const [qrValue, setQrValue] = useState(null);
	const timerRef = useRef(null);

	useEffect(() => {
		if (order) initPayment();
		return clearPollTimer;
	}, [order]);

	useEffect(() => {
		if (status === "confirmed") {
			init_cart();
			loadNextSplittedOrder();
			setSatispayPopup(false);
			window.parent.postMessage("close", "*");
		}
	}, [status]);

	const initPayment = async () => {
		clearPollTimer();
		try {
			const params = new URLSearchParams({
				mandant_id: apiSettings.mandant.id,
				order_id: order.id,
				shop_id: order.shop_id,
				origin: "pos",
			});
			const json = await api.get("/plugins/satispay2/init_qr_payment.php?" + params.toString());
			if (json.success === 0) {
				setStatus("error");
			} else {
				setQrValue(json.data.redirect_url);
				setStatus("qr");
				timerRef.current = setTimeout(pollOrderStatus, 5000);
			}
		} catch (e) {
			setStatus("error");
		}
	};

	const pollOrderStatus = async () => {
		const res = await api.postProtected("/orders/get/" + order.id + "/", {
			fields: ["status"],
		});
		if (res.success === 0) {
			setStatus("error");
		} else {
			const orderStatus = res.data.status;
			if (orderStatus === "confirmed" || orderStatus === "payment_error") {
				setStatus(orderStatus);
			} else {
				timerRef.current = setTimeout(pollOrderStatus, 5000);
			}
		}
	};

	const clearPollTimer = () => {
		if (!timerRef.current) return;
		clearTimeout(timerRef.current);
		timerRef.current = null;
	};

	const retry = async () => {
		clearPollTimer();
		setStatus("loading");
		setQrValue(null);
		const res = await api.postProtected("/orders/edit/" + order.id + "/", {
			status: "awaiting_payment",
		});
		if (res.success === 0) {
			setStatus("error");
		} else {
			await initPayment();
		}
	};

	const cancel = () => {
		clearPollTimer();
		setConfirm({
			title: "Attenzione",
			message: "Sei sicuro di annullare il pagamento Satispay?",
			onConfirm: async () => {
				if (!edit) {
					setLoading(true);
					const res = await api.postProtected("/orders/edit/" + order.id + "/", {
						status: "archived",
					});
					setLoading(false);
					if (res.success === 1) {
						setSatispayPopup(false);
					} else {
						setConfirm({ title: "Errore", message: res.error });
					}
				} else {
					setSatispayPopup(false);
				}
			},
		});
	};

	return (
		<PopUp
			customClass="satispay-payment"
			size=""
			options={{
				title: "Pagamento Satispay",
				onClose: false,
			}}
		>
			{status === "loading" && (
				<div className="satispay-inner">
					<LoadIcon className="rotate" />
					<p>Inizializzazione pagamento...</p>
				</div>
			)}

			{status === "qr" && (
				<div className="satispay-inner">
					<div className="satispay-qr-wrapper">
						<QRCodeSVG value={qrValue} size={240} />
					</div>
					<p className="satispay-instruction">Scansiona con Satispay</p>
					<button onClick={cancel} className="button-cancel satispay-cancel-button">
						Annulla
					</button>
				</div>
			)}

			{status === "payment_error" && (
				<div className="satispay-inner satispay-error">
					<p>Pagamento non riuscito</p>
					<div className="satispay-actions">
						<button onClick={retry} className="button-confirm">Riprova</button>
						<button onClick={cancel} className="button-cancel">Annulla</button>
					</div>
				</div>
			)}

			{status === "error" && (
				<div className="satispay-inner satispay-error">
					<p>Errore inizializzazione pagamento</p>
					<div className="satispay-actions">
						<button onClick={retry} className="button-confirm">Riprova</button>
						<button onClick={cancel} className="button-cancel">Annulla</button>
					</div>
				</div>
			)}
		</PopUp>
	);
}

export default SatispayPopup;
